<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-file-pdf-o fa-fw"></i>Emissão de Certificados
          </h1>
        </div>
      </div>
      <div class="col-lg-7" v-if="msg">
        <div
          class="alert"
          v-bind:class="[info ? 'alert-success' : 'alert-danger']"
        >
          <span><i class="fa fa-exclamation fa-fw"></i>{{ msg }}</span>
        </div>
      </div>
	  <hr/>
      <div class="row">
        <form
          class="col-lg-12"
          role="form"
          @submit.stop.prevent="emitCertificate"
        >
          <div class="row">
            <div>
              <label>Empresa </label>
              <Select2
                class="select"
                v-model="person"
                :options="persons"
                placeholder="Escolha uma Empresa"
              >
                <h3>{{ person }}</h3>
              </Select2>
            </div>
            <br />
            <br />
            <div>
              <label>Atividade</label>
              <Select2
                class="select"
                v-model="activity"
                :options="activities"
                placeholder="Escolha uma Atividade"
              >
                <h3>{{ activity }}</h3>
              </Select2>
            </div>
            <br />
            <br />
            <div>
              <label>Data de Validade</label>
              <input class="form-control" v-model="validity" type="date" />
            </div>
          </div>
          <br />
          <br />
          <button type="submit" class="btn btn-block btn-info">
            Emitir Certificado
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Select2 from "v-select2-component";

export default {
  name: "EmitCertificate",
  inject: ["loading"],
  components: { Select2 },
  data() {
    return {
      search: "",
      person: {},
      persons: [],
      activity: {},
      activities: [],
      showByIndex: null,
      pageable: {},
      totalPages: null,
      totalElements: null,
      size: null,
      certificate: {},
      certificates: [],
      validity: null,
      msg: null,
      info: false,
	  deferred: false,
    };
  },

  mounted() {
    this.loading.value = true;
    this.$http
      .get("activity")
      .then((response) => {
        this.activities = response.data.reduce((acc, { id, name: text }) => {
          acc.push({ id, text });
          return acc;
        }, []);
        this.goToPage();
        this.info = false;
        this.msg = null;
      })
      .catch((error) => console.log(error));
    setTimeout(() => (this.loading.value = false), 1000);
  },

  methods: {
    goToPage(page) {
      if (page == undefined) {
        page = 0;
      }

      this.$http
        .get(`person?page=${page}&quantity=10000&orderBy=id`)
        .then((response) => {
          this.persons = response.data.content.reduce(
            (acc, { id, name: text }) => {
              acc.push({ id, text });
              return acc;
            },
            []
          );
        });
    },
    emitCertificate() {
      this.loading.value = true;
      if (this.person == undefined || this.activity == undefined) {
        return;
      }
      this.certificate.person = this.person;
      this.certificate.activity = this.activity;
      this.certificate.validity = this.validity;
      this.$http
        .post("certificate", this.certificate)
        .then((response) => {
          this.certificate = {};
          this.person = {};
          this.activity = {};
          this.validity = null;
          this.certificates.push(response.data);
          this.info = true;
          this.msg = "Certificado gerado com sucesso!";
        })
        .catch((error) => {
          if (error.response) {
            this.info = false;
            this.msg = "Preencha todos os campos";
          }
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    ValidityCertificates(){
      if(this.emitCertificate() && this.deferred){
        console.log("falta fazer essa função")
      }
    }
  },

  computed: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/EmitCertificate.vue